export const orderDataByCreatedAt = <T extends { createdAt: number }>(data: T[]): T[] => {
  return data.sort((a, b) => {
    return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
  });
};
